// extracted by mini-css-extract-plugin
export default {"readMoreReveal":"ReadMoreReveal_readMoreReveal__JOciP"};